import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { A } from '@ember/array';
import { action } from '@ember/object';
import { task, timeout } from 'ember-concurrency';
import { sort, filter, uniqBy, union } from '@ember/object/computed';

import ActivityItem from 'seshy/faux-models/activity/item';

export default class ActivityListDayProjectComponent extends Component {
  @tracked _topLevelItems = A([]);

  latestActivitySorting = ['latestActivityTimestamp:desc'];
  @sort('_topLevelItems', 'latestActivitySorting') topLevelItems;

  buildTopLevelItems = task(async () => {
    //console.log('##################################################')
    //console.log('## starting buildTopLevelItems')
    for (const item of this.args.items) {
      let itemKey = item.constructor.modelName + '-' + item.id;

      let itemData = ActivityItem.create({
        id: itemKey,
        item: item,
        showFullItem: true,
      });

      this._topLevelItems.pushObject(itemData);
    }
    //console.log('items = ', items);
  });

  getTopLevelItemForItem(item) {
    let topLevelItemForItem = item;
    //console.log('looking for ', item.constructor.modelName, item.id)
    if (item.type == 'state-change') {
      topLevelItemForItem = item.issue;
    } else if (item.constructor.modelName == 'comment') {
      if (item.type == 'issue') {
        topLevelItemForItem = item;
      } else if (item.bounce) {
        topLevelItemForItem = item;
      } else if (item.comment) {
        let upperComment = item.comment;
        if (upperComment.bounce) {
          topLevelItemForItem = item.comment;
        } else if (upperComment.type == 'issue') {
          topLevelItemForItem = upperComment;
        } else {
          topLevelItemForItem = upperComment.projectVersion;
        }
      } else {
        topLevelItemForItem = item.projectVersion;
      }
    }
    return topLevelItemForItem;
  }
}
